import { createAction, props } from '@ngrx/store';
import { Company, GetCompanyPayload, PaginatedResponse, User } from '@interfaces';
import {
  CreateManagerOpts,
  ManagerOfCompany,
  SearchManagersOfCompanyOpts,
  UpdateManagerOpts,
} from 'src/app/_interfaces/manager';

export const getCompanies = createAction('[Company] Get Companies', props<{ payload: GetCompanyPayload }>());
export const getCompaniesSuccess = createAction(
  '[Company] Get Companies Success',
  props<{ companies: PaginatedResponse<Company> }>()
);
export const getCompaniesError = createAction('[Company] Get Companies Error', props<{ errorMessage: any }>());

export const getCompaniesBasicDataList = createAction(
  '[Company] Get Companies Basic Data List',
  props<{ payload: GetCompanyPayload }>()
);
export const getCompaniesBasicDataListSuccess = createAction(
  '[Company] Get Companies Basic Info List Success',
  props<{ companies: PaginatedResponse<Company> }>()
);
export const getCompaniesBasicDataListError = createAction(
  '[Company] Get Companies Basic Info List Error',
  props<{ errorMessage: any }>()
);

export const getCompanyBasicData = createAction(
  '[Company] Get Company Basic Data',
  props<{ payload: { id: string } }>()
);
export const getCompanyBasicDataSuccess = createAction(
  '[Company] Get Company Basic Info Success',
  props<{ company: Company }>()
);
export const getCompanyBasicDataError = createAction(
  '[Company] Get Company Basic Info Error',
  props<{ errorMessage: any }>()
);

export const getCompany = createAction('[Company] Get Company', props<{ companyId: string }>());
export const getCompanySuccess = createAction('[Company] Get Company Success', props<{ company: Company }>());
export const getCompanyError = createAction('[Company] Get Company Error', props<{ errorMessage: any }>());
export const resetLoadedComapny = createAction('[Company] Reset stored company data');

export const createCompany = createAction('[Company] Create Company', props<{ company: Company }>());
export const createCompanySuccess = createAction(
  '[Company] Create Company Success',
  props<{ createdCompany: Company }>()
);
export const createCompanyError = createAction('[Company] Create Company Error', props<{ errorMessage: any }>());

export const updateCompany = createAction('[Company] Update Company', props<{ companyId: string; company: Company }>());
export const updateCompanySuccess = createAction(
  '[Company] Update Company Success',
  props<{ updatedCompany: Company }>()
);
export const updateCompanyError = createAction('[Company] Update Company Error', props<{ errorMessage: any }>());

// export const removeCompany = createAction('[Company] Remove Company', props<{ companyId: string }>());
// export const removeCompanySuccess = createAction('[Company] Remove Company Success', props<{ removedCompanyId: string }>());
// export const removeCompanyError = createAction('[Company] Remove Company Error', props<{ errorMessage: any }>());

export const setIsActiveCompany = createAction(
  '[Company] Change isActive Company',
  props<{ companyId: string; isActive: boolean }>()
);
export const setIsActiveCompanySuccess = createAction(
  '[Company] Change isActive Company Success',
  props<{ updatedCompany: Company }>()
);
export const setIsActiveCompanyError = createAction(
  '[Company] Change isActive Company Error',
  props<{ errorMessage: string }>()
);

export const createManager = createAction('[Company] Create Manager', props<{ payload: CreateManagerOpts }>());
export const createManagerSuccess = createAction(
  '[Company] Create Manager Success',
  props<{ manager: Partial<User> }>()
);
export const createManagerError = createAction('[Company] Create Manager Error', props<{ errorMessage: string }>());

export const getManagerDetails = createAction('[Company] Get Manager Details', props<{ managerId: string }>());
export const getManagerDetailsSuccess = createAction(
  '[Company] Get Manager Details SUCCESS',
  props<{ manager: Partial<User> }>()
);
export const getManagerDetailsError = createAction(
  '[Company] Get Manager Details ERROR',
  props<{ errorMessage: string }>()
);

export const updateManager = createAction(
  '[Company] Update Manager',
  props<{ payload: UpdateManagerOpts; userId: string }>()
);
export const updateManagerSuccess = createAction(
  '[Company] Update Manager SUCCESS',
  props<{ manager: Partial<User> }>()
);
export const updateManagerError = createAction('[Company] Update Manager ERROR', props<{ errorMessage: string }>());

export const softRemoveManager = createAction('[Company] Soft Remove Manager', props<{ managerId: string }>());
export const softRemoveManagerSuccess = createAction(
  '[Company] Soft Remove Manager SUCCESS',
  props<{ manager: Partial<User> }>()
);
export const softRemoveManagerError = createAction(
  '[Company] Soft Remove Manager ERROR',
  props<{ errorMessage: string }>()
);

export const restoreManager = createAction('[Company] Restore Manager', props<{ managerId: string }>());
export const restoreManagerSuccess = createAction(
  '[Company] Restore Manager SUCCESS',
  props<{ manager: Partial<User> }>()
);
export const restoreManagerError = createAction('[Company] Restore Manager ERROR', props<{ errorMessage: string }>());

export const searchManagersOfCompany = createAction(
  '[Company] Search Managers Of Company',
  props<{ payload: SearchManagersOfCompanyOpts }>()
);
export const searchManagersOfCompanySuccess = createAction(
  '[Company] Search Managers Of Company SUCCESS',
  props<{ managers: PaginatedResponse<Partial<User>> }>()
);
export const searchManagersOfCompanyError = createAction(
  '[Company] Search Managers Of Company Error',
  props<{ errorMessage: string }>()
);

export const addManagedCompany = createAction(
  '[Company] Add Company to managers list of managed companies ',
  props<{ companyId: string; managerId: string }>()
);
export const addManagedCompanySuccess = createAction(
  '[Company] Add Company to managers list of managed companies SUCCESS',
  props<{ managedCompany: Partial<ManagerOfCompany> }>()
);
export const addManagedCompanyError = createAction(
  '[Company] [Company] Add Company to managers list of managed companies ERROR',
  props<{ errorMessage: string }>()
);

export const removeManagedCompany = createAction(
  '[Company] Remove assignment of company to manager (remove company from managedCompanies list)',
  props<{ mocId: string; managerId: string }>()
);
export const removeManagedCompanySuccess = createAction(
  '[Company] Remove assignment of company to manager (remove company from managedCompanies list)SUCCESS',
  props<{ removedMoc: Partial<ManagerOfCompany> }>()
);
export const removeManagedCompanyError = createAction(
  '[Company] Remove assignment of company to manager (remove company from managedCompanies list)ERROR',
  props<{ errorMessage: string }>()
);

export const resendManagerActivation = createAction(
  '[Company] Resend manager activation link',
  props<{ email: string; userId: string }>()
);
export const resendManagerActivationSuccess = createAction(
  '[Company] Resend manager activation link SUCCESS',
  props<{ emailSent: boolean }>()
);
export const resendManagerActivationError = createAction(
  '[Company] Resend manager activation link ERROR',
  props<{ errorMessage: string }>()
);

export const getCompanyOfSelfRegistered = createAction('[Company] Get Company of Self Registered users');
export const getCompanyOfSelfRegisteredSuccess = createAction(
  '[Company] Get Company of Self Registered users SUCCESS',
  props<{ company: Partial<Company> }>()
);
export const getCompanyOfSelfRegisteredError = createAction(
  '[Company] Get Company of Self Registered users ERROR',
  props<{ errorMessage: any }>()
);

export const getAllActiveCompanies = createAction('[Company] Get All Active Companies Basic Data');
export const getAllActiveCompaniesSuccess = createAction(
  '[Company] Get All Active Companies Basic Data SUCCESS',
  props<{ allActiveCompanies: Partial<Company>[] }>()
);
export const getAllActiveCompaniesError = createAction(
  '[Company] Get All Active Companies Basic Data ERROR',
  props<{ errorMessage: string }>()
);
